(($, Drupal, once) => {
  Drupal.behaviors.myModuleBehavior = {
    attach: (/* context, settings */) => {
      const $languageSwitcher = $(once("languageSwitcher", ".js-language-switcher"));

      const $activeLi = $languageSwitcher.find(".is-active");

      if (!$activeLi.length) {
        const searchClass = `.${drupalSettings.path.currentLanguage}`;
        const $currentLi = $languageSwitcher.find(searchClass);
        $currentLi.addClass("is-active");
      }

      $activeLi.on("click", (e) => {
        e.preventDefault();
      });

      $languageSwitcher.on("click", (e) => {
        const $target = $(e.currentTarget);
        if ($target.hasClass("is-active")) {
          $target.removeClass("is-active");
        } else {
          $target.addClass("is-active");
        }
      });
    },
  };
})(jQuery, Drupal, once);
